import {Loader2} from "lucide-react";

import {cn} from "@/lib/utils";

type LoaderProps = {
  className?: string;
  /** sm = inline panels; md = sections/modals; lg = full-screen (default for overlay). */
  size?: "sm" | "md" | "lg";
};

const SPINNER_CLASS = {
  sm: "size-4",
  md: "size-6",
  lg: "size-10",
} as const;

const LABEL_CLASS = {
  sm: "text-xs",
  md: "text-sm",
  lg: "text-sm",
} as const;

export default function Loader({className, size}: LoaderProps) {
  const useFixedOverlay = !className || className === "h-screen";
  const resolvedSize = size ?? (useFixedOverlay ? "lg" : "md");

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center",
        useFixedOverlay ? "fixed inset-0 z-50" : className,
      )}
    >
      <div
        className={cn(
          "flex flex-col items-center justify-center",
          resolvedSize === "sm" ? "gap-1" : "gap-2",
        )}
      >
        <Loader2
          className={cn(SPINNER_CLASS[resolvedSize], "animate-spin text-primary")}
          aria-hidden
        />
        <p className={cn("text-muted-foreground", LABEL_CLASS[resolvedSize])}>Loading</p>
      </div>
    </div>
  );
}
